import parsePhoneNumberFromString from 'libphonenumber-js';
import { getPhoneNumberInfo } from 'src/components/Inputs/InputPhone/utils/getPhoneNumberInfo';

export const validatePhoneNumber = (value: string) => {
  const normalizedValue = value.includes('+') ? value : `+${value}`;
  const parsePhone = parsePhoneNumberFromString(normalizedValue);

  if (value === '') {
    return undefined;
  }

  if (getPhoneNumberInfo(value, parsePhone?.country)?.isValid) {
    return undefined;
  }

  return 'validation.invalidPhoneNumber';
};
